import * as React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const LegacyLayout = ({ children, location: _location }) => {
  return (
    <div className="min-h-screen bg-off-white font-optima text-gray-800">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-white text-gray-900 px-4 py-2 rounded-lg z-50"
      >
        Skip to main content
      </a>
      <Navigation />

      {/* Main Content - Removed animation to prevent CLS */}
      <div>{children}</div>

      <Footer />

      {/* Custom Styles */}
      <style>{`
        /* Menu Animation Styles */
        .menu-icon-container {
          position: relative;
          width: 24px;
          height: 24px;
        }
        .menu-open, .menu-close {
          position: absolute;
          top: 0;
          left: 0;
          transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
        }
        .menu-close {
          transform: rotate(-90deg);
          opacity: 0;
        }
        .icon-active .menu-open {
          transform: rotate(90deg);
          opacity: 0;
        }
        .icon-active .menu-close {
          transform: rotate(0);
          opacity: 1;
        }

        /* Fade-in Animation */
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LegacyLayout; 